import { useState } from 'react'
import { BaseModal } from './BaseModal'
import { StandardRulesModal } from './StandardRulesModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  const [isStandardRulesModalOpen, setIsStandardRulesModalOpen] =
    useState(false)
  return (
    <>
      <BaseModal
        title="How to play"
        isOpen={isOpen}
        handleClose={isStandardRulesModalOpen ? () => undefined : handleClose}
      >
        <p className="mt-6 text-m text-gray-500 dark:text-gray-300">
          <button
            className="underline font-bold"
            onClick={() => setIsStandardRulesModalOpen(true)}
          >
            Standard Wordle rules apply
          </button>
        </p>

        <p className="mt-6 text-sm text-gray-500 dark:text-gray-300">
          In addition, you may only guess words that have been spoken in the
          televised main series of <i>Doctor Who</i> (including proper nouns).
          For example, <b>BENNI</b> is a valid guess but <b>FOXES</b> is not.
        </p>

        <p className="mt-6 text-sm text-gray-500 dark:text-gray-300">
          Daily answers are hand-picked to have some significance to the series
          but may be appallingly niche. Brave heart!
        </p>

        <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
          This is a modified version of open source project{' '}
          <a
            href="https://github.com/cwackerfuss/react-wordle"
            className="underline font-bold"
          >
            cwackerfuss/react-wordle
          </a>{' '}
          based on the original game by Jason Wardle.
        </p>
        <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
          Words and statistics data-mined from{' '}
          <a
            href="http://www.chakoteya.net/index.html"
            className="underline font-bold"
          >
            Chrissie's Doctor Who Transcripts
          </a>
          . If you enjoy this game, please consider supporting her work.
        </p>
      </BaseModal>

      <StandardRulesModal
        isOpen={isStandardRulesModalOpen}
        handleClose={() => setIsStandardRulesModalOpen(false)}
      />
    </>
  )
}
